import Vue from "vue"
import Vuex from "vuex"
import {getRoutes} from "@/api/resources/menu";
import {recursion} from "@/utils/filters";

Vue.use(Vuex)
export default new Vuex.Store({
    // 全局属性变量
    state: { // state的作用是定义属性变量。定义一个参数
        secret: undefined,
        nodeList: [],
        selectArray: [],
        historyList: [],
        keyList: [],
        routerList: [],
        loading: false,
        darker: false,
        background: true
    },
    mutations: {
        setBackground(state, background) {
            state.background = background;
        },
        setDarker(state, darker) {
            state.darker = darker;
        },
        setLoading(state) {
            state.loading = true;
        },
        clearLoading(state) {
            state.loading = false;
        },
        setRouter(state, routerList) {
            recursion(routerList)
            state.routerList = routerList
        },
        setSecret(state, secret) {
            state.secret = secret;
        },
        setSelectArray(state, selectArray) {
            state.selectArray = selectArray
        },
        setNodeList(state, nodeList) {
            state.nodeList = nodeList
        },
        setKeyList(state, key) {
            let list = [
                ...state.keyList
            ]
            if (!list) {
                state.keyList = []
                state.keyList.push(key)
            } else {
                let index = list.findIndex(item => item.value === key.value)

                if (index !== -1) {
                    list.splice(index, 1);
                }

                list.push(key);

                state.keyList = list.sort((a, b) => {
                    return b.time - a.time;
                });
            }
        },

        delKeyList(state, param) {
            let list = [
                ...state.keyList
            ]

            let index = list.findIndex(item => item.value === param.value);

            if (index !== -1) {
                list.splice(index, 1);

                state.keyList = list
            }
        },

        clearKeyList(state) {
            state.keyList = []
        },


        setHistory(state, history) {
            let list = [
                ...state.historyList
            ]
            if (!list) {
                state.historyList = []
                state.historyList.push(history)
            } else {
                let index = list.findIndex(item => item.vid === history.vid && item.eid === history.eid)

                if (index === -1) {
                    list.push(history);
                } else {
                    list[index] = history
                }
                state.historyList = list.sort((a, b) => {
                    return b.time - a.time;
                });
            }
        },

        delHistory(state, param) {
            let list = [
                ...state.historyList
            ]

            let r = list.filter(item => {
                return  item.vid === param.vid
            });

            r.forEach(item => {
                let index = list.findIndex(i => i.vid === item.vid && i.eid === item.eid)
                if (index !== -1) {
                    list.splice(index, 1);
                    state.historyList = list
                }
            })
        },
        clearHistory(state) {
            state.historyList = []
        },
        setSelected(state, params) {

            let selected = [
                ...state.selectArray
            ]

            let _index = selected.findIndex(item => item.name === params.node)

            let item = {
                ...selected[_index]
            }

            item.list[params.current].push(params.value);

            selected[_index] = item

            state.selectArray = selected

            // uni.setStorageSync('selectArray', selected)
        },
        delSelected(state, params) {
            let selected = [
                ...state.selectArray
            ]

            let _index = selected.findIndex(item => item.name === params.node)

            let item = {
                ...selected[_index]
            }

            item.list[params.current].splice(params.index, 1)

            selected[_index] = item

            state.selectArray = selected

        }
    },
    getters: {
        getSecret: state => state.secret,
        getNodeList: (state) => state.nodeList,
        getSelected: (state) => state.selectArray,
        getCurrentSelected: (state) => state.selectArray,
        getHistoryList: (state) => state.historyList,
        getKeyList: (state) => state.keyList,
        getRoutes: (state) => state.routerList,
        getLoading: (state) => state.loading,
        getDarker: (state) => state.darker,
        getBackground: (state) => state.background,
    },
    actions: {
        getRouteList({commit}) {
            return new Promise((resolve) => {
                getRoutes().then((res) => {
                    let data = res.data.data
                    // 注意这里取出的是 JSON 格式的路由列表
                    commit('setRouter', data)
                    resolve()
                })
            })
        }
    }
})
